function getPercents(value, total, digits = 1) {
	if (total === 0) return 0;
	return +((value / total) * 100).toFixed(digits);
}

export default getPercents;
